import { IconSocialsDzen } from '@/icon/socials/Dzen';
import { IconSocialsOk } from '@/icon/socials/Ok';
import { IconSocialsTaplink } from '@/icon/socials/Taplink';
import { IconSocialsTg } from '@/icon/socials/Tg';
import { IconSocialsVk } from '@/icon/socials/Vk';
import { IconSocialsWa } from '@/icon/socials/Wa';
import { IconSocialsYoutube } from '@/icon/socials/Youtube';
import { IconStoresApple } from '@/icon/stores/Apple';
import { IconStoresGooglePlay } from '@/icon/stores/GooglePlay';
import { IconStoresHuaweiStore } from '@/icon/stores/HuaweiStore';
import { IconStoresRuStore } from '@/icon/stores/RuStore';

export const iconNavigateMapper: Record<string, React.ElementType> = {
  dzen: IconSocialsDzen,
  ok: IconSocialsOk,
  telegram: IconSocialsTg,
  vk: IconSocialsVk,
  whatsApp: IconSocialsWa,
  youtube: IconSocialsYoutube,
  taplink: IconSocialsTaplink,
  appStore: IconStoresApple,
  googlePlay: IconStoresGooglePlay,
  huaweiStore: IconStoresHuaweiStore,
  ruStore: IconStoresRuStore
};
